/**
* DevExpress HTML/JS Reporting (viewer\mobile\internal\_mobilePage.js)
* Version:  23.1.6
* Build date: Oct 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { PreviewPage } from '../../internal/_page';
export class MobilePreviewPage extends PreviewPage {
    constructor(preview, pageIndex, processClick, loading) {
        super(preview, pageIndex, processClick, loading);
        this.maxZoom = 1;
        this.selectBrick = (path, ctrlKey) => {
            var currentBrick = this.brick();
            !ctrlKey && this.resetBrickRecusive(currentBrick);
            if (!path) {
                return;
            }
            if (!currentBrick) {
                this['_selectedBrickPath'] = path;
                return;
            }
            this.bricks().forEach((brick) => { brick.indexes === path && brick.active(true); });
        };
    }
}
